import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

interface InputBoxSsnProps {
  label: string;
  name: string;
  value: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  errorFeedback?: any;
  onChange?: any;
  onBlur?: any;
  setFieldValue: any;
  isValid?: any;
  isInvalid?: any;
}

const maskSSN = (value: string) => {
  // ONLY NUMBERS
  // // Remove all non-digit characters
  // const onlyNums = value.replace(/\D/g, "");

  // // when the type is password - show only numbers
  // return onlyNums;

  // Remove all non-digit characters
  const onlyNums = value.replace(/\D/g, '');

  // Format the string with hyphens
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 5) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 5)}-${onlyNums.slice(5, 9)}`;
};

export const InputBoxSsn: React.FC<InputBoxSsnProps> = ({
  label,
  name,
  type = 'text',
  placeholder,
  required = false,
  value,
  errorFeedback,
  onChange,
  setFieldValue,
  onBlur,
  isValid,
  isInvalid,
}) => {
  const [showSSN, setShowSSN] = useState(false);

  useEffect(() => {
    setFieldValue(name, value);
  }, [value, setFieldValue, name]);

  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label>{label}</Form.Label>
      <InputGroup hasValidation>
        <Form.Control
          type={showSSN ? 'text' : 'password'}
          name={name}
          placeholder={placeholder ?? 'xxx-xx-xxxx'}
          required={required}
          value={value}
          onChange={(e) => {
            const maskedValue = maskSSN(e.target.value);
            setFieldValue(name, maskedValue);
          }}
          onBlur={onBlur}
          isValid={isValid}
          isInvalid={isInvalid}
          maxLength={11}
        />
        <InputGroup.Text onClick={() => setShowSSN(!showSSN)} style={{ cursor: 'pointer' }}>
          {showSSN ? <FaEyeSlash /> : <FaEye />}
        </InputGroup.Text>

        <Form.Control.Feedback type="invalid">{errorFeedback}</Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  );
};
